import React, {useState} from "react";
import {CircularProgress} from "@mui/material";
import Box from "@mui/material/Box";
import UploadFilesForm from "../../form/UploadFilesForm";

const UploadGroupOfMaterialFileForm = ({
                                           label, uploadData, multiple, handleModalAlert
                                       }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleUpload = async (event) => {
        setIsLoading(true)
        event.preventDefault();
        uploadData.downloadFile(multiple ? selectedFile : selectedFile[0])
            .then(function () {
                handleModalAlert("Отправлено", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(function () {
                setIsLoading(false)
                event.target.reset();
                setSelectedFile(null)
            })
    };

    return (
        <div>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '3px',
            }}>
                <Box sx={{marginRight: '10px'}}>
                    <UploadFilesForm
                        uploadData={uploadData}
                        handleUpload={handleUpload}
                        selectedFiles={selectedFile}
                        setSelectedFiles={setSelectedFile}
                        label={label}
                        multiple={multiple}
                    />
                </Box>
                <Box sx={{height: "40px", display: "flex", alignItems: "center"}}>{isLoading && <CircularProgress
                    color={'primary'}
                    size={30}
                    thickness={4}
                />}
                </Box>
            </Box>
        </div>
    );
};

export default UploadGroupOfMaterialFileForm;